import React from "react";

import Contact from "../../components/Contact.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";
import { Helmet } from "react-helmet-async";

const OpenCart = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById("contact-section");
    contactSection.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="OpenCart Development Company creating fast, secure, and custom eCommerce stores. Boost your online sales with our expert OpenCart development services."
        />
        <meta name="copyright" content="codeglim" />
        <meta
          property="og:title"
          content="OpenCart Development Company for Your Custom e-Store | Ayanshtech Solutions"
        />
        <meta property="og:site_name" content="Ayanshtech Solutions" />
        <meta
          property="og:url"
          content="https://ayanshtechnology.com/opencart"
        />
        <meta
          property="og:description"
          content="OpenCart Development Company creating fast, secure, and custom eCommerce stores. Boost your online sales with our expert OpenCart development services."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@Ayanshtech Solutions" />
        <meta
          name="twitter:title"
          content="OpenCart Development Company for Your Custom e-Store | Ayanshtech Solutions"
        />
        <meta
          name="twitter:description"
          content="OpenCart Development Company creating fast, secure, and custom eCommerce stores. Boost your online sales with our expert OpenCart development services."
        />
        <meta
          name="twitter:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <link rel="canonical" href="https://ayanshtechnology.com/opencart" />
        <title>
          OpenCart Development Company for Your Custom e-Store | Ayanshtech
          Solutions
        </title>
      </Helmet>
      <div className="flex flex-col items-center justify-center p-6 gradient-background">
        <div className=" w-full">
          <div className="flex flex-col lg:flex-row items-center lg:space-x-16">
            <div className="lg:w-3/4 lg:text-left p-4 mt-10">
              <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
                OpenCart Development Company for Your Custom eCommerce Store
              </h1>
              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                Boost your online business with a trusted OpenCart Development
                Company that delivers custom eCommerce solutions tailored to
                your brand. We specialize in building high-performing, visually
                stunning, and user-friendly OpenCart stores designed to attract
                customers and drive conversions.
                <br />
                Whether you’re launching a new eCommerce store or upgrading your
                existing platform, our expert developers ensure your website
                reflects your vision, enhances user engagement, and delivers
                smooth navigation across all devices.
                <br />
                From custom OpenCart module development and third-party
                integrations to speed optimization and security enhancements, we
                provide complete OpenCart solutions that empower your business
                to grow. Our goal is to create a scalable, secure, and
                future-ready eCommerce store that stands out in today’s
                competitive digital marketplace.
              </p>

              <button
                onClick={scrollToContact}
                className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold py-2 px-4 rounded-full mt-6"
              >
                Get Started
              </button>
            </div>

            <div className="flex justify-center mb-12 lg:mb-0 mt-5">
              <img
                src="\assets\images\softwareDev\opencart\img2.webp"
                alt="OpenCart Development Company"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>
          </div>
        </div>

        <div className="text-center mb-5 mt-10">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Key Features of Our OpenCart Development Services
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Leverage the power of OpenCart to create eCommerce stores that are
            robust, scalable, and tailored to your business requirements.
          </p>
        </div>

        <div className=" ">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon10.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Custom Theme Development</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon11.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Custom Module Development</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon12.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Third-Party Integrations</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon13.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Support and Maintenance</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon14.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Performance Optimization</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon15.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Enhanced Security Features</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon16.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Platform Migration Services</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon17.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Mobile-Friendly Design</p>
            </div>
          </div>
        </div>

        <div className="text-center  mt-20">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Why Choose Our OpenCart Development Services?
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Our OpenCart development services focus on delivering secure,
            scalable, and feature-rich eCommerce solutions to help your business
            thrive.
          </p>
        </div>

        <div className=" ">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="w-full md:w-1/3 p-4">
              <img
                src="\assets\images\softwareDev\opencart\img1.jpg"
                alt="OpenCart Demo"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>

            <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon18.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Scalable solutions for growing businesses
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon19.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Fully customizable designs and features
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon20.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Enhanced user experience for better engagement
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon7.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Reliable security to protect your data
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <AyanshtechAdvantage />

        <div id="contact-section">
          <Contact />
        </div>

        <GetInTouch />
      </div>
    </>
  );
};

export default OpenCart;
